import config from '@/config'

export default {
  combine: {
    confirm_password: "Sahkan @:ui.password",
    change_password: "Tukar @:ui.password",
    old_password: "Lama @:ui.password",
    new_password: "@:ui.new @:ui.password",
    account_status: "@:ui.account @:ui.status",
    confirm_security_code: "Sahkan @:ui.security_code",
    first_time_login: "Log Masuk Kali Pertama",
    security_authentication: "Pengesahan Keselamatan",
    update_security: "Kemas Kini Keselamatan",
    disable_security: "Nyahaktifkan Keselamatan",
    add_operator: "Tambah Pengendali",
    add_account: "Tambah Akaun",
    add_sub_account: "Tambah Sub Akaun",
    edit_operator: "Edit Pengendali",
    edit_account: "Edit Akaun",
    edit_member: "Edit Ahli",
    approve_ticket: "Luluskan Tiket",
    reject_ticket: "Tolak Tiket",
    add_bank_account: "Tambah Akaun Bank",
    edit_bank_account: "Edit Akaun Bank",
    reset_threshold: "Reset Ambang",
    adjust_balance: "Laraskan Baki",
    adjust_member: "Laraskan Ahli",
    configure_bank_setting: "Konfigurasi Tetapan Bank",
    account_setup: "Persediaan Akaun",
    bank_transfer: "Pemindahan Bank",
    edit_bank_member: "Edit Ahli Bank",
    view_ticket: "Paparan Tiket",
    edit_ticket: "Edit Tiket",
    edit_vip: "Edit VIP",
    report: "Laporan",
    knock_off_promo: "Promosi Knock Off",
    edit_authority: "Edit Kewenangan",
    reset_password: "Reset Kata Laluan",
    update_password: "Kemas Kini Kata Laluan",
    member_summary: "Ringkasan Ahli",
    reply_review: "Balas Ulasan",
    edit_affiliate: "Edit Afiliasi",
    edit_bank_affiliate: "Edit Afiliasi Bank",
    approve_affiliate_ticket: "Luluskan Tiket Afiliasi",
    check_free_spin: "Semak Putaran Percuma",
    reject_affiliate_ticket: "Tolak Tiket Afiliasi",
    wallet_adjust: "Laraskan Dompet",
    update_comm_package: "Kemas Kini Pakej Komisen",
    approve_affiliate: "Luluskan Afiliasi",
    sub_acc_detail_affiliate: "Detail Sub Akaun Afiliasi",
    get_tac: "Dapatkan OTP",
    add_coupon: "Tambah Kupon",
    update_coupon: "Kemas Kini Kupon",
    issue_free_spin: "Terbitkan Putaran Percuma",
    get_bank_tac: "Dapatkan OTP Bank",
    update_global_setting: "Kemas Kini Tetapan Global",
    add_platform: "Tambah Platform",
    edit_platform: "Edit Platform",
    add_bank_group: "Tambah Kumpulan Bank",
    edit_bank_group: "Edit Kumpulan Bank",
    update_maintenance_schedule: "Kemas Kini Jadual Penyelenggaraan",
    add_withdrawal_limit: "Tambah Had Pengeluaran",
    edit_withdrawal_limit: "Edit Had Pengeluaran",
    add_campaign: "Tambah Kempen",
    edit_campaign: "Edit Kempen",
    add_promo_group: "Tambah Kumpulan Promosi",
    edit_promo_group: "Edit Kumpulan Promosi",
    update_team: "Kemas Kini Pasukan",
    update_result: "Kemas Kini Keputusan",
    insert_result: "Masukkan Keputusan",
    bet_list: "Senarai Pertaruhan",
    result_list: "Senarai Keputusan",
    add_promo: "Tambah Promosi",
    raise_deposit_ticket: "Tingkatkan Tiket Deposit",
    bank_adjust: "Larasan Bank",
    promo_member_assign: "Peruntukkan Ahli Promosi",
    bonus_issue: "Isu Bonus",
    update_vip: "Kemas Kini VIP",
    update_member_profile: "Kemas Kini Profil Ahli",
    change_withdrawal_limit: "Tukar Had Pengeluaran",
    change_bank_group: "Tukar Kumpulan Bank",
    change_promotion_group: "Tukar Kumpulan Promosi",
    promotion_signup: "Pendaftaran Promosi",
    edit_promo_signup: "Edit Pendaftaran Promosi",
    update_provider_bet_limit: "Kemas Kini Had Pertaruhan Penyedia",
    update_bet_limit: "Kemas Kini Had Pertaruhan",
    update_member_bet_limit: "Kemas Kini Had Pertaruhan Ahli",
    edit_bank_account_group: "Edit Kumpulan Akaun Bank",
    redeposit_ticket: "Tiket Deposit Semula",
    edit_promotion_group: "Edit Kumpulan Promosi",
    edit_promotion_group_norm: "Urus Promosi Dalam Kumpulan",
    get_inbox_list: "Dapatkan Senarai Inbox",
    view_result_changes_detail: "Lihat Detail Perubahan Keputusan",
    edit_promotion_signup: "Edit Pendaftaran Promosi",
    edit_bet_limit: "Edit Had Pertaruhan",
    edit_provider_game_off: "Edit Permainan Penyedia Off",
    edit_provider_rtp: "Edit RTP Penyedia",
    get_rebate: "Dapatkan Rebat",
    get_recent_deposit: "Dapatkan Deposit Terkini",
    add_survey: "Tambah Tinjauan",
    add_announcement_banner: "Tambah Banner Pengumuman",
    edit_announcement_banner: "Edit Banner Pengumuman",
    move_announcement_banner: "Gerakkan Banner Pengumuman",
    add_promotion_banner: "Tambah Banner Promosi",
    edit_promotion_banner: "Edit Banner Promosi",
    move_promotion_banner: "Alih Banner Promosi",
    add_slide_banner: "Tambah Banner Slide",
    edit_slide_banner: "Edit Banner Slide",
    move_slide_banner: "Alih Banner Slide",
    add_seo_page: "Tambah Halaman SEO",
    edit_seo_page: "Edit Halaman SEO",
    clear_outstanding: "Kosongkan Tunggakan",
    add_ip_whitelist: "Tambah Senarai Putih IP",
    edit_payment_option_provider: "Edit Penyedia Pilihan Pembayaran",
    bonus_issue_bulk: "Isu Bonus Secara Pukal",
    edit_bank_member_ewallet: "Edit Ahli Bank (E-Wallet)",
    redeposit: "Deposit Semula",
    reject_approved_ticket: "Tolak Tiket yang Diluluskan",
    audit_ticket: "Audit Tiket",
    review_ticket: "Semak Tiket",
    edit_promotion_group_norm_seq: "Urus Urutan Promosi Dalam Kumpulan",
    edit_promo_provider_list: "Edit Senarai Penyedia Promosi",
    edit_promo_payment_option: "Edit Pilihan Pembayaran Promosi",
    edit_campaign_provider_list: "Edit Senarai Penyedia Kempen",
    update_global_setting_affiliate: "Kemas Kini Tetapan Global (Afiliasi)",
    update_comm: "Kemas Kini Komisen",
    update_carry_over: "Kemas Kini Bawa Ke Hadapan",
    review_affiliate_ticket: "Semak Tiket Afiliasi",
    audit_affiliate_ticket: "Audit Tiket Afiliasi",
    get_tac_affiliate: "Dapatkan OTP (Afiliasi)",
    raise_deposit_ticket_gateway: "Buat Tiket Deposit (Gateway)",
    member_details: "Maklumat Ahli",
    direct_audit_ticket: "Audit Tiket (Langsung)",
    get_rollback_detail: "Dapatkan Butiran Rollback",
    get_reject_detail: "Dapatkan Butiran Tolak",
    manual_approve_ticket: "Luluskan Tiket (Manual)",
    add_label: "Tambah Label",
    edit_label: "Sunting Label",
    set_bank_default_sender: "Tetapkan Pengirim Lalai Bank",
    rollback_processing_ticket: "Batalkan Pemprosesan Tiket",
    update_iframe_url: "Kemas Kini URL Iframe",
    edit_exchange_rate: "Sunting Kadar Pertukaran",
    add_vip: "Tambah VIP",
    add_turnover_tier: "Tambah Tahap Perolehan",
    edit_turnover_tier: "Sunting Tahap Perolehan",
    get_member_label_list: "Senarai Label Ahli",
    add_rescue_fund: "Tambah Dana Penyelamat",
    get_custom_member_list: "Senarai Ahli Tersuai",
    get_rescue_fund_provider: "Dapatkan Penyedia Dana Penyelamat",
    add_game_exclude: "Tambah Pengecualian Permainan",
    domain_assign: "Tugaskan Ahli Domain",
    domain_custom_add_assign: "Tambah Domain",
    add_domain_batch: "Tambah Domain (Secara Kumpulan)",
    update_payment_provider_vip: "Kemas Kini Pembekal Pembayaran Vip",
    update_campaign: "Kemas Kini Kempen",
    purchase_domain: "Beli Domain",
    apply_domain: "Permohonan Domain",
    edit_access_control: "Sunting Kawalan Akses",
    edit_access_auto: "Edit Pelantikan Automatik",
    add_domain: "Tambah domain",
    operator_balance_topup: "Tambah Saldo",
    operator_wallet_adjust: "Laraskan Dompet Operator",
    update_payment_provider_desc: "Kemas Kini Penerangan Pembekal Pembayaran",
    update_payment_option_desc: "Kemas Kini Penerangan Pilihan Pembayaran",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    edit_profile: "@:ui.edit @:ui.profile",
    update_setting: "@:ui.update @:ui.setting",
    edit_domain: "@:ui.edit @:ui.domain",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Tetapkan Logo",
    operator_security_deposit_adjust: "Laraskan Dana Keselamatan",
    manual_process: "Proses Manual",
    update_permitted_amount: "Kemas Kini Jumlah Dibenarkan",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    edit_provider: "@:ui.edit_provider",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    add_reward: "@:ui.add @:ui.reward",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
  },
  short: {
    deposit_amount: "Jumlah Deposit",
    base_amount: "Jumlah Asas",
    bonus_amount: "Jumlah Bonus",
    target_amount: "Jumlah Sasaran",
    accumulate_amount: "Jumlah Akaun",
    knockoff_by: "Diluluskan Oleh",
    knockoff_date: "Tarikh Lulus",
    incoming_threshold: "Ambang Masuk",
    incoming_frequency: "Kekerapan Masuk",
    outgoing_threshold: "Ambang Keluar",
    outgoing_frequency: "Kekerapan Keluar",
    account_balance: "Baki Akaun",
    claim_type: "Jenis Akaun",
    bonus_rate: "Kadar Asas",
    max_bonus: "Bonus Maksimum",
    rollover: "Rollover",
    criteria: "Kriteria",
    start_time: "Masa Mula",
    end_time: "Masa Tamat",
    monday: "Isnin",
    tuesday: "Selasa",
    wednesday: "Rabu",
    thursday: "Khamis",
    friday: "Jumaat",
    saturday: "Sabtu",
    sunday: "Ahad",
    status: "Status",
    bonus_rate_percent: "Kadar Asas (%)",
    valid_turnover: "Perolehan Sah",
    deposit_count: "Bilangan Deposit",
    withdrawal_amount: "Jumlah Pengeluaran",
    withdrawal_count: "Bilangan Pengeluaran",
    bonus_amount: "Jumlah Bonus",
    adjustment_amount: "Jumlah Pelarasan",
    referee_count: "Bilangan Perujuk",
    signup_count: "Bilangan Pendaftaran",
    verified_count: "Bilangan VRF",
    active_member: "Ahli Aktif",
    ftd_count: "Bilangan FTD",
    ftd_amount: "Jumlah FTD",
    working_date: "Tarikh Kerja",
    bet_count: "Bilangan Pertaruhan",
    recipient_bank_id: "ID Bank Penerima",
    recipient_bank_acc_no: "No. Akaun Bank Penerima",
    recipient_bank_acc_holder: "Pemegang Akaun Bank Penerima",
    sender_bank: "Bank Pengirim",
    sender_bank_acc_no: "No. Akaun Bank Pengirim",
    sender_bank_acc_holder: "Pemegang Akaun Bank Pengirim",
    unique_login_count: "Bilangan Log Masuk Pengguna",
    unique_withdrawal_count: "Bilangan Pengeluaran Pengguna",
    second_deposit_count: "Bilangan Deposit Pengirim",
    reject_date: "Tarikh Penerimaan",
    processing_date: "Tarikh Proses",
    deposit_withdrawal_different: "Perbezaan Deposit-Pengeluaran",
    external_id: "ID Eksekutif",
    draft_version: "Versi Draf",
    prod_version: "Versi Produk",
    purchased_date: "Tarikh Produk"
  },
  date_ranges: {
    0: "Hari Ini",
    1: "Semalam",
    2: "Bulan Ini",
    4: "Bulan Lalu",
  },
  langList: {
    EN: "Bahasa Inggeris",
    CN: "Bahasa Cina",
    PHP: "Filipina",
    esp: "Bahasa Sepanyol"
  },
  cartStep: {
    SETUP: "PERSIAPAN",
    DOMAIN: "DOMAIN",
    THEME: "UI",
    THEME_COLOR: "WARNA TEMA",
    PAYMENT: "GERBANG PEMBAYARAN",
    SUMMARY: "RINGKASAN",
    OPERATOR_INFO: "TETAPAN OPERATOR"
  },
  menulist: {
    home: "Halaman Utama",
    hot: "Permainan Panas",
    slot_game: "Permainan Slot",
    casino: "Kasino",
    sportsbook: "Sports",
    fishing: "Memancing",
    lottery: "Loteri",
    poker: "Poker",
    hash_game: "Permainan Hash",
    sabong: "Sabong",
    promotion: "Promosi",
    review: "Ulasan",
    news: "Berita",
    live_stream: "Siaran Langsung",
    vip: "VIP",
    referral: "Rujukan",
    favourite: "Kegemaran",
    mission: "Misi (Permainan Mini)",
    spin: "Putar",
    leaderboard: "Papan Pendahulu",
    account: "Akaun",
    deposit: "Deposit",
    withdrawal: "Pengeluaran",
    bet_history: "Sejarah Pertaruhan",
    pending_status: "Status Tertunda",
    change_password: "Tukar Kata Laluan",
    profile: "Profil",
    banking_details: "Butiran Perbankan",
    inbox: "Peti Masuk",
    voucher: "Baucar",
    wallet: "Dompet",
    statement: "Penyata",
    download: "Muat Turun",
    game: "Permainan",
    special: "Istimewa",
    misc: "Lain-lain",
    contact_us: "Hubungi Kami",
    e_sportsbook: "E-Sportsbook",
    lotto: "Lotto",
    p2p: "P2P",
    other: "Lain-lain",
    vip2: "VIP2",
    referral2: "Rujukan2",
    event: "Acara",
    daily_reward: "Ganjaran Harian",
    play2earn: "Main untuk Dapatkan",
    redemption: "Penebusan",
    card_board: "Papan Kad",
    lobby: "Lobi",
    in_house: "Dalam Rumah",
    transfer: "Pindahan",
    horse_racing: "Perlumbaan Kuda",
    register: "Daftar",
    login: "Log Masuk",
    transaction_history: "Sejarah Transaksi",
    bingo: "Bingo",
    member: "Ahli",
    arcade: "Arked",
    crash: "Roket Pertaruhan"
  },
  cartStatus: {
    ALL: "SEMUA",
    ACTIVE: "AKTIF",
    PENDING_PAYMENT: "PEMBAYARAN TERTUNDA",
    PURCHASED: "DIBELI",
    PENDING_SETUP: "PERSIAPAN TERTUNDA",
    COMPLETED: "SELESAI",
    FAILED: "GAGAL",
    TIMEOUT: "HABIS MASA",
    REJECTED: "DITOLAK"
  },

  ok: "OK",
  cancel: "Batal",
  login: "Log Masuk",
  logout: "Log Keluar",
  add: "Tambah",
  edit: "Edit",
  delete: "Padam",
  refresh: "Segarkan",
  action: "Tindakan",
  id: "ID",
  name: "Nama",
  all: "Semua",
  search: "Cari",
  remove: "Alih Keluar",
  save: "Simpan",
  account: "Akaun",
  settings: "Tetapan",
  on: "HIDUP",
  off: "MATI",
  new: "Baru",
  clear: "Kosongkan",
  users: "Pengguna | Pengguna-pengguna",
  username: "Nama Pengguna",
  password: "Kata Laluan",
  created_on: "Dicipta Pada",
  active: "Aktif",
  page_size: "Saiz Halaman",
  status: "Status",
  fullname: "Nama Penuh",
  result: "Keputusan",
  version: "Versi",
  close: "Tutup",
  back: "Kembali",
  show: "Tunjukkan",
  login_id: "ID Log Masuk",
  logs: "Log | Log-log",
  date_time: "Tarikh & Masa",
  ip_address: "Alamat IP",
  domain_name: "Nama Domain",
  browser_agent: "Ejen Pelayar",
  action_by: "Dilakukan Oleh",
  details: "Butiran",
  key: "Kunci | Kunci-kunci",
  value: "Nilai | Nilai-nilai",
  from: "Dari",
  to: "Ke",
  type: "Jenis",
  criteria: "Kriteria",
  log: "Log",
  report: "Laporan",
  security_tag: "Tag Keselamatan",
  security_code: "Kod Keselamatan",
  submit: "Hantar",
  disable: "Lumpuhkan",
  operators: "Operator | Operator-operator",
  members: "Ahli",
  account_id: "ID Akaun",
  confirm_password: "Sahkan Kata Laluan",
  full_name: "Nama Penuh",
  contact_phone: "Telefon Perhubungan",
  contact_email: "E-mel Perhubungan",
  dashboard: "Papan Pemuka",
  sub_account: "Akaun Sub",
  authority_option: "Pilihan Kuasa",
  banks: "Bank | Bank-bank",
  login_ip : "IP Log Masuk",
  block: "Sekat",
  profile_id: "ID Profil",
  suspend: "Gantung",
  dob: "Tarikh Lahir",
  mail_address: "Alamat Mel",
  deposit: "Deposit",
  withdrawal: "Pengeluaran",
  rejected: "Ditolak",
  processed: "Diproses",
  pending: "Tertunda",
  member: "Ahli",
  amount: "Jumlah",
  bank_acc_no: "No. Akaun Bank",
  deposit_date: "Tarikh Deposit",
  deposit_method: "Kaedah Deposit",
  approve: "Luluskan",
  reject: "Tolak",
  remark: "Catatan",
  ticket_detail: "Perincian Tiket",
  promo: "Promosi",
  package: "Pakej",
  created_date: "Tarikh Dicipta",
  currency: "Mata Wang",
  bank_acc_holder: "Pemegang Akaun Bank",
  ref_no: "No. Rujukan",
  vip: "VIP",
  requirement: "Keperluan",
  modified_date: "Tarikh Diubah",
  modified_by: "Diubah Oleh",
  bank_member: "Ahli Bank",
  bank_operator: "Operator Bank",
  bank_name: "Nama Bank",
  bank_acc_type: "Jenis Akaun Bank",
  account_balance: "Baki Akaun",
  threshold: "Ambang",
  incoming: "Masuk",
  outgoing: "Keluar",
  frequency: "Kekerapan",
  reset_threshold: "Tetapkan Semula Ambang",
  adjust_balance: "Sesuaikan Baki",
  bank_from: "Dari Bank",
  bank_to: "Ke Bank",
  attachment: "Lampiran",
  sender_bank: "Bank Pengirim",
  sender_bank_acc_no: "Penghantar Bank Acc No.",
  sender_bank_acc_holder: "Pemegang Akaun Bank Pengirim",
  audit: "Audit",
  action_status: "Status Tindakan",
  action_date: "Tarikh Tindakan",
  promotion: "Promosi",
  promo_id: "ID Promosi",
  promo_name: "Nama Promosi",
  package_id: "ID Pakej",
  claim_type: "Jenis Tuntutan",
  bonus_rate: "Kadar Bonus",
  max_bonus: "Bonus Maksimum",
  rollover: "Gulung Semula",
  start_date: "Tarikh Mula",
  end_date: "Tarikh Tamat",
  adj_amount: "Sesuaikan Jumlah",
  promotion_member: "Ahli Promosi",
  on_going: "Sedang Berjalan",
  knock_off: "Ketepikan",
  all_ongoing: "Semua Sedang Berjalan",
  deposit_amount: "Jumlah Deposit",
  base_amount: "Jumlah Asas",
  bonus_amount: "Jumlah Bonus",
  target_amount: "Jumlah Sasaran",
  claim_date: "Tarikh Tuntutan",
  accumulate_win: "Menang Terkumpul",
  accumulate_turnover: "Perolehan Terkumpul",
  package: "Pakej",
  bonus: "Bonus",
  bonus_log: "Log Bonus",
  member_id: "ID Ahli",
  before_balance: "Baki Sebelum",
  transfer_amount: "Jumlah Pemindahan",
  after_balance: "Baki Selepas",
  created_by: "Dibuat Oleh",
  bonus_name: "Nama Bonus",
  bonus_desc: "Penerangan Bonus",
  bonus_type: "Jenis Bonus",
  add_promo: "Tambah Promosi",
  bonus_value: "Nilai Bonus",
  attach_promo: "Lampirkan Promosi",
  daily_statement: "Penyata Harian",
  working_date: "Tarikh Bekerja",
  opening_balance: "Baki Pembukaan",
  turnover: "Perolehan",
  valid_turnover: "Perolehan Sah",
  winlose: "MenangKalah",
  withdrawal_amount: "Jumlah Pengeluaran",
  closing_balance: "Baki Penutupan",
  sub_total: "Sub Jumlah",
  grand_total: "Jumlah Besar",
  daily_winlose: "MenangKalah Harian",
  game_result_slots: "Keputusan Permainan (Slot)",
  game_result_livecasino: "Keputusan Permainan (Livecasino)",
  game_result_rebate: "Keputusan Permainan (Rebat)",
  game_result_sportsbook: "Keputusan Permainan (Sukan)",
  game_result_cockfight: "Keputusan Permainan (Cockfight)",
  game_result_rescue: "Keputusan Permainan (Rescue)",
  game_result: "Keputusan Permainan",
  bet_count: "Kiraan Taruhan",
  result_id: "ID Keputusan",
  bet_time: "Masa Taruhan",
  payout: "Bayaran",
  game_type: "Jenis Permainan",
  game_name: "Nama Permainan",
  game_provider: "Penyedia Permainan",
  reset: "Tetapkan Semula",
  mode: "Mod",
  balance: "Baki",
  min_bal_knock_off_promo: "Min Baki. (Untuk tamat promosi automatik)",
  social_account: "Akaun Sosial",
  wechat: "Wechat",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Log Masuk",
  platform: "Platform",
  bank_statement: "Penyata Bank",
  transfer_date: "Tarikh Pemindahan",
  detail: "Perincian",
  date: "Tarikh",
  transfer_list: "Senarai Pemindahan",
  credit: "Kredit",
  debit: "Debit",
  month: "Bulan",
  unblock: "Nyahsekat",
  unblock_member: "Nyahsekat Ahli",
  unblock_operator: "Nyahsekat Operator",
  after_balance: "Baki Selepas",
  referrer_id: "Referrer ID",
  referrer_code: "Kod Perujuk",
  referral_code: "Kod Rujukan",
  bonus_and_adjustment: "Bonus & Pelarasan",
  adjustment: "Pelarasan",
  incoming_amount_threshold: "Ambang Jumlah Masuk",
  outgoing_amount_threshold: "Ambang Jumlah Keluar",
  knock_off_by: "Ditamatkan Oleh",
  knock_off_date: "Tarikh Tamat",
  accumulate_amount: "Jumlah Terkumpul",
  total_turnover: "Jumlah Perolehan",
  total_winlose: "Jumlah MenangKalah",
  total_deposit: "Jumlah Deposit",
  total_member: "Jumlah Ahli",
  active_player: "Pemain Aktif",
  top_winner: "Pemenang Teratas",
  top_loser: "Kalah Teratas",
  winner: "Pemenang",
  loser: "Kalah",
  deposit_count: "Kiraan Deposit",
  withdrawal_count: "Kiraan Pengeluaran",
  bet_count: "Jumlah Pertaruhan",
  alert: "Amaran",
  incoming_threshold: "Ambang Masuk",
  incoming_frequency: "Kekerapan Masuk",
  outgoing_threshold: "Ambang Keluar",
  outgoing_frequency: "Kekerapan Keluar",
  reset_password: "Tetapkan Semula Kata Laluan",
  authority_option: "Pilihan Kuasa",
  transfer: "Pemindahan",
  company_bank: "Bank Syarikat",
  company_bank_acc_no: "No. Akaun Bank Syarikat",
  company_bank_acc_holder: "Pemegang Akaun Bank Syarikat",
  registered_member: "Ahli Berdaftar",
  promotion_report: "Laporan Promosi",
  deposited_member: "Ahli Mendeposit",
  referred_member: "Ahli Dirujuk",
  validated_on: "Disahkan Pada",
  first_deposit: "Deposit Pertama",
  nickname: "Nama Samaran",
  reward: "Ganjaran",
  inbox: "Peti Masuk",
  manual_bonus: "Bonus Manual",
  review: "Ulasan | Ulasan",
  reviews: "Ulasan",
  review_list: "Senarai Ulasan",
  review_detail: "Butiran Ulasan",
  reply_review: "Balas Ulasan",
  comment: "Komen",
  reply: "Balas",
  recipient_no: "No. Penerima",
  question : "Soalan",
  rating: "Penilaian",
  content: "Kandungan",
  image: "Imej",
  monthly_rating: "Penilaian Bulanan",
  affiliate: "Afiliasi",
  affiliate_list: "Senarai Afiliasi",
  affiliate_code: "Kod Afiliasi",
  approved_by: "Diluluskan Oleh",
  approved_date: "Tarikh Diluluskan",
  bank_affiliate: "Bank Afiliasi",
  bank_id: "ID Bank",
  ticket_detail_affiliate: "Butiran Tiket Afiliasi",
  pending_application: "Permohonan Tertangguh",
  pending_withdrawal: "Pengeluaran & Semakan Tertangguh",
  pending_review_withdrawal: "Pengeluaran & Semakan Tertangguh",
  unblock_affiliate: "Nyahsekat Afiliasi",
  wallet_adjust: "Pelarasan Dompet",
  comm_package: "Pakej Komisen",
  affiliate_id: "ID Afiliasi",
  sub_account_detail: "Butiran Akaun Sub",
  comm_log: "Log Komisen",
  earning_breakdown: "Pecahan Pendapatan",
  daily_winlose_member: "Ahli MenangKalah Harian",
  total_revenue: "Jumlah Pendapatan",
  player_id: "ID Pemain",
  daily_winlose_affiliate: "MenangKalah Harian (Afiliasi)",
  daily_deposit_affiliate: "Deposit Harian (Afiliasi)",
  comm_package_old: "Pakej Komisen Lama",
  comm_package_new: "Pakej Komisen Baru",
  export_excel: "Eksport Excel",
  get_tac: "Dapatkan OTP",
  tac_code: "Kod OTP",
  expiry_date: "Tarikh Luput",
  inactive: "Tidak Aktif",
  player_list: "Senarai Pemain",
  last_deposit_date: "Tarikh Deposit Terakhir",
  last_deposit_amount: "Jumlah Deposit Terakhir",
  never_deposited: "Tidak Pernah Mendeposit",
  coupon: "Kupon",
  allocated: "Diperuntukkan",
  claimed: "Dituntut",
  approved: "Diluluskan",
  coupon_code: "Kod Kupon",
  coupon_quota: "Kuota Kupon",
  current_allocated: "Diperuntukkan Semasa",
  new_allocated: "Diperuntukkan Baru",
  update : "Kemas Kini",
  tac_validated: "OTP Disahkan",
  copy: "Salin",
  bonus_rate_percent : "Kadar Bonus (%)",
  coupon_desc: "Penerangan Kupon",
  both: "Kedua-duanya",
  issue_free_spin: "Berikan Putaran Percuma",
  game: "Permainan",
  max_win_amount: "Jumlah Kemenangan Maksimum",
  utm_list: "Senarai UTM",
  search_by_member: "Cari Mengikut Ahli",
  source: "Sumber",
  campaign: "Kempen",
  deposited: "Telah Mendeposit",
  search_by_id: "Cari Mengikut ID",
  get_bank_tac: "Dapatkan OTP Bank",
  bank_statement_daily: "Penyata Bank (Harian)",
  transfer_type: "Jenis Pemindahan",
  audit_freebies_list: "Senarai Hadiah Percuma",
  acknowledge: "Akui",
  submit_acknowledgement: "Hantar Pengakuan",
  is_ack: "Adakah Diakui",
  yes: "Ya",
  no: "Tidak",
  audit_rescue_fund_list: "Senarai Dana Penyelamatan Audit",
  global_setting: "Tetapan Global",
  signup_ip: "IP Daftar",
  last_login_ip: "IP Log Masuk Terakhir",
  last_login_time: "Masa Log Masuk Terakhir",
  link: "Pautan",
  is_default: "Adalah Lalai",
  is_public: "Adalah Awam",
  bank_group: "Kumpulan Bank",
  set_default: "Tetapkan Lalai",
  group_id: "ID Kumpulan",
  group_name: "Nama Kumpulan",
  provider_maintenance: "Penyelenggaraan Penyedia",
  provider_code: "Kod Penyedia",
  provider_name: "Nama Penyedia",
  withdrawal_limit: "Had Pengeluaran",
  limit_id: "ID Had",
  limit_name: "Nama Had",
  daily_amount: "Jumlah Harian",
  daily_frequency: "Kekerapan Harian",
  promotion_id: "ID Promosi",
  promotion_name: "Nama Promosi",
  withhold_bonus: "Tahan Bonus",
  withhold_amount: "Jumlah Tahan",
  withhold_amt: "Jumlah Tahan",
  max_withdraw_amt: "Jumlah Pengeluaran Maksimum",
  max_withdraw_amount: "Jumlah Pengeluaran Maksimum",
  monday: "Isnin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Khamis",
  friday: "Jumaat",
  saturday: "Sabtu",
  sunday: "Ahad",
  start_time: "Masa Mula",
  end_time: "Masa Tamat",
  day: "Hari | Hari-Hari",
  coupon_status: "Status Kupon",
  campaign_id: "ID Kempen",
  campaign_name: "Nama Kempen",
  promotion_group: "Kumpulan Promosi",
  referee_list: "Senarai Pengadil",
  account_verified: "Akaun Disahkan",
  verified_date: "Tarikh Disahkan",
  ticket_list: "Senarai Tiket",
  vip_id: "ID VIP",
  vip_name: "Nama VIP",
  self_rebate_rate: "Kadar Rebat Diri Sendiri (%)",
  downline_rebate_rate: "Kadar Rebat Downline (%)",
  provider: "Penyedia",
  match_id: "ID Perlawanan",
  home_team: "Pasukan Tuan Rumah",
  away_team: "Pasukan Pelawat",
  home_team_new: "Pasukan Tuan Rumah Baru",
  away_team_new: "Pasukan Pelawat Baru",
  updated_by: "Dikemas Kini Oleh",
  updated_on: "Dikemas Kini Pada",
  home_score: "Skor Rumah",
  away_score: "Skor Jauh",
  home_score_new: "Skor Tuan Rumah Baru",
  away_score_new: "Skor Pelawat Baru",
  team: "Pasukan",
  match_time: "Masa Perlawanan",
  match_round: "Pusingan Perlawanan",
  home_group: "Kumpulan Tuan Rumah",
  away_group: "Kumpulan Pelawat",
  match: "Perlawanan",
  match_status: "Status Perlawanan",
  insert: "Sisip",
  pin: "Pin",
  bet_list: "Senarai Pertaruhan",
  result_list: "Senarai Keputusan",
  bet_id: "ID Pertaruhan",
  bet_home: "Pertaruhan Tuan Rumah",
  bet_away: "Pertaruhan Pelawat",
  bet_on: "Pertaruhan Pada",
  min_deposit: "Deposit Minimum",
  min_withdrawal: "Pengeluaran Minimum",
  raise_deposit_ticket: "Tiket Deposit Tinggi",
  method: "Kaedah",
  one_time_depositor: "Pendeposit Sekali",
  current_month_non_depositor: "Pendeposit Bulan Semasa",
  current_month_no_login: "Tiada Log Masuk Bulan Semasa",
  ticket_date: "Tarikh Tiket",
  ftd_amount: "Jumlah FTD",
  bonus_issue: "Isu Bonus",
  promotion_summary: "Ringkasan Promosi",
  promotion_summary_detail: "Ringkasan Promosi (Butiran)",
  claim_frequency: "Kekerapan Tuntutan",
  provider_list: "Senarai Penyedia",
  platform_winlose: "Kemenangan/Kerugian Platform",
  adjustment_amount: "Jumlah Penyesuaian",
  referee_count: "Bilangan Pengadil",
  category: "Kategori",
  update_vip: "Kemas Kini VIP",
  update_member_profile: "Kemas Kini Profil Ahli",
  promotion_signup: "Pendaftaran Promosi",
  provider_bet_limit: "Had Pertaruhan Penyedia",
  update_member_bet_limit: "Kemas Kini Had Pertaruhan Ahli",
  bet_limit: "Had Pertaruhan",
  sports_game: "Sukan/Permainan",
  match_time: "Waktu Perlawanan",
  league_name: "Nama Liga",
  home_team_name: "Nama Pasukan Tuan Rumah",
  away_team_name: "Nama Pasukan Pelawat",
  home_score: "Skor Rumah",
  away_score: "Skor Pelawat",
  wl_status: "Winlose Status",
  available_bank_account: "Akaun Bank Tersedia",
  group_bank_account: "Akaun Bank Kumpulan",
  edit_bank_group: "Edit Kumpulan Bank",
  edit_bank_account_group: "Edit Kumpulan Akaun Bank",
  redeposit: "Deposit semula",
  upline: "Talian atas",
  downline: "Turunkan",
  available_promotion: "Promosi Tersedia",
  group_promotion: "Promosi Kumpulan",
  edit_promotion_group: "Edit Kumpulan Promosi",
  edit_promotion_group_norm: "Urus Promosi Dalam Kumpulan",
  balance_before: "Imbangan Sebelum",
  balance_after: "Imbangan Selepas",
  signup_count: "Kiraan Tanda Tangan",
  verified_count: "Kiraan Disahkan",
  active_member: "Ahli Aktif",
  ftd_count: "Kiraan FTD",
  daily_summary_company: "Ringkasan Harian (Syarikat)",
  daily_summary_operator: "Ringkasan Harian (Operator)",
  daily_summary_member: "Ringkasan Harian (Ahli)",
  daily_ledger_operator: "Lejar Harian (Operator)",
  adjustment_list: "Senarai Pelarasan",
  bonus_list: "Senarai Bonus",
  ltd_date: "Tarikh LTD",
  adjustment_log: "Log Pelarasan",
  get_inbox: "Dapatkan Peti Masuk",
  is_claimed: "Dituntut",
  mix_parlay: "Mix Parlay",
  event: "Acara",
  result_changes_log: "Log Perubahan Keputusan",
  view_detail: "Lihat Butiran",
  total_referee: "Jumlah Pengadil",
  verified_signup: "Disahkan / Daftar",
  ftd: "FTD | Deposit Kali Pertama",
  raw_msg: "Mesej Mentah",
  unselect_all: "Nyahpilih Semua",
  select_all: "Pilih Semua",
  edit_bet_limit: "Edit Had Pertaruhan",
  provider_game_off: "Permainan Penyedia Dimatikan",
  provider_hot_game: "Permainan Panas Penyedia",
  game_id : "ID permainan",
  game_list: "Senarai Permainan",
  off_list: "Di Luar Senarai",
  provider_rtp: "Penyedia RTP",
  rtp: "RTP",
  signup_date: "Tarikh Daftar",
  free_credit: "Kredit Percuma",
  get_rebate: "Dapatkan Rebat",
  downline_rebate: "Turunkan Rebat",
  game_rebate: "Rebat Permainan",
  rebate: "Bebat",
  ftd_date: "Tarikh FTD",
  provider_winlose_company: "Penyedia Winlose (Syarikat)",
  provider_winlose_operator: "Penyedia Winlose (Operator)",
  report_promotion: "Laporan (Promosi)",
  already_hit: "Sudah Pukul",
  ongoing: "Sedang berlangsung",
  members_export: "Ahli (Eksport)",
  get_recent_deposit: "Dapatkan Deposit Terkini",
  recent_deposit: "Deposit Terkini",
  survey_list: "Senarai Tinjauan",
  modified_on: "Diubah suai Pada",
  cms: "CMS",
  announcement_banner: "Sepanduk Pengumuman",
  promotion_banner: "Sepanduk Promosi",
  slide_banner: "Sepanduk Gelongsor",
  seo_page: "Halaman SEO",
  en_title: "Tajuk (EN)",
  cn_title: "Tajuk (CN)",
  local_title: "Tajuk (TEMPATAN)",
  en_img: "Imej (EN)",
  cn_img: "Imej (CN)",
  local_img: "Imej (TEMPATAN)",
  before_login: "Sebelum Log Masuk",
  after_login: "Selepas Log Masuk",
  en: "EN",
  move_up: "Bergerak",
  move_down: "Bergerak ke bawah",
  banner_type: "Jenis Sepanduk",
  default_order: "Perintah Lalai",
  item_order: "Pesanan Item",
  title: "Tajuk",
  banner_id: "ID sepanduk",
  order: "Pesan",
  body: "Badan",
  en_image: "Imej (EN)",
  local_image: "Imej (TEMPATAN)",
  move: "Bergerak",
  en_img_desktop: "Desktop Imej (EN)",
  cn_img_desktop: "Desktop Imej (CN)",
  local_img_desktop: "Desktop Imej (TEMPATAN)",
  en_img_mobile: "Imej Mudah Alih (EN)",
  cn_img_mobile: "Imej Mudah Alih (CN)",
  local_img_mobile: "Imej Mudah Alih (TEMPATAN)",
  login_required: "Log Masuk Diperlukan",
  new_window_tab: "Tetingkap / Tab Baharu",
  current_page: "Halaman Semasa",
  target: "Sasaran",
  alt: "Alt",
  href: "Href",
  image_desktop: "Imej Desktop",
  image_mobile: "Imej Mudah Alih",
  en_alt: "Alt (EN)",
  local_alt: "Alt (TEMPATAN)",
  en_href: "Href (EN)",
  local_href: "Href (TEMPATAN)",
  en_image_desktop: "Imej Desktop (EN)",
  active_period: "Tempoh Aktif",
  en_item: "Item (EN)",
  local_item: "Item (TEMPATAN)",
  meta_title: "Tajuk Meta",
  meta_keywords: "Kata Kunci Meta",
  meta_url: "URL Meta",
  meta_canonical: "Meta Canonical",
  meta_author: "Pengarang Meta",
  meta_publisher: "Penerbit Meta",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Desc",
  meta_image: "Imej Meta",
  page: "Halaman",
  item: "Item",
  remove_desktop_image: "Alih Keluar Imej Desktop",
  remove_mobile_image: "Alih Keluar Imej Mudah Alih",
  page_name: "Nama Halaman",
  login_date: "Tarikh Log Masuk",
  ftd_amount_min: "Min. Jumlah FTD",
  ftd_amount_max: "Max. Jumlah FTD",
  fl_provider_code: "Penyedia Pelancaran Pertama",
  fl_game_id: "ID Permainan Pelancaran Pertama",
  fl_game_name: "Nama Permainan Pelancaran Pertama",
  no_deposit: "Tiada Deposit",
  no_login: "Tiada Log Masuk",
  top_deposit: "Deposit Teratas",
  top_withdrawal: "Pengeluaran Teratas",
  top_promotion: "Promosi Teratas",
  outstanding_balance: "Imbangan Cemerlang",
  last_update_time: "Masa Kemas Kini Terakhir",
  trace: "Jejak",
  trace_outstanding: "Jejak Cemerlang",
  outstanding: "Cemerlang",
  clear_outstanding: "Clear Cemerlang",
  meta_image_url: "Meta Image Url",
  member_bonus: "Bonus Ahli",
  delete_after_bonus: "Padam Selepas Bonus",
  crm_list: "Senarai CRM",
  advance_search: "Carian Awal",
  deposit_count_from: "Deposit Kiraan Daripada",
  deposit_count_to: "Deposit Dikira Kepada",
  deposit_amount_from: "Deposit Amaun Daripada",
  deposit_amount_to: "Jumlah Deposit Kepada",
  min_day_no_login: "Min. Day Tiada Log Masuk",
  min_day_no_deposit: "Min. Hari Tiada Deposit",
  last_login: "Log Masuk Terakhir",
  last_deposit: "Deposit Terakhir",
  phone: "Telefon",
  email: "E-mel",
  ip_whitelist: "Senarai Putih IP",
  ip: "IP",
  payment_option: "Pilihan Pembayaran",
  payment_mode: "Mod Pembayaran",
  payment_desc: "Payment Desc",
  edit_provider: "Edit Pembekal",
  success: "KEJAYAAN",
  failed: "GAGAL",
  failed_members: "Ahli Gagal",
  bank_member_ewallet: "Ahli Bank (E-Wallet)",
  processing: "Memproses",
  recipient_bank_id: "ID Bank Penerima",
  recipient_bank_acc_no: "No. Acc Bank Penerima",
  ticket_auto_withdrawal_log: "Log Tiket (Pengeluaran Auto)",
  resubmit_ticket: "Serah tiket",
  ticket_export: "Tiket (Eksport)",
  export_deposit: "Eksport (Deposit)",
  export_deposit_all: "Eksport Semua (Deposit)",
  export_withdrawal: "Eksport (Pengeluaran)",
  export_withdrawal_all: "Eksport Semua (Pengeluaran)",
  export_member_all: "Eksport Semua (Ahli)",
  processed_rejected: "Diproses (Ditolak)",
  channel: "Saluran",
  influencer: "Pengaruh",
  ticket_id: "ID tiket",
  recommend: "Cadangkan",
  sequence: "Jujukan",
  progress: "Kemajuan",
  statement_info: "Maklumat Kenyataan",
  member_info: "Maklumat Ahli",
  slots: "Slot",
  livecasino: "Livecasino",
  sportsbook: "Buku Sukan",
  cockfight: "Pertarungan ayam",
  member_list: "Senarai Ahli",
  member_details: "Butiran Ahli",
  operator: "Operator",
  game_balance: "Imbangan Permainan",
  claim_limit: "Had Tuntutan",
  max_withdraw_multiple: "Max Menarik Berbilang",
  login_count: "Kiraan Log Masuk",
  ip_info: "Maklumat IP",
  payment_gateway: "Gerbang Pembayaran",
  min_limit: "Had Min",
  max_limit: "Had Maks",
  unique_member_count: "Kiraan Ahli Unik",
  total: "Jumlah",
  success_rate: "Kadar Kejayaan",
  rebate_summary: "Ringkasan Debat",
  rebate_summary_daily: "Ringkasan Debat Setiap Hari",
  rebate_member: "Ahli Debat",
  self: "Diri",
  system_balance: "Imbangan Sistem",
  rejected_onload: "Ditolak (Muat)",
  no_bonus: "Tiada Bonus",
  review_audit_ticket: "Tiket Semakan & Audit",
  audit_ticket: "Tiket Audit",
  review_ticket: "Tiket Semakan",
  edit_promotion_group_norm_seq: "Urus Urutan Promosi Dalam Kumpulan",
  bank_provider: "Penyedia Bank",
  member_custom_vip: "Vip Tersuai Ahli",
  unlock: "Buka kunci",
  signup_bonus: "Bonus Signup",
  global_setting_affiliate: "Tetapan Global (Afiliasi)",
  carry_over: "Teruskan",
  comm_sports: "Suruhanjaya (Sukan)",
  comm_slots: "Suruhanjaya (Slot)",
  comm_livecasino: "Suruhanjaya (Livecasino)",
  comm_cockfight: "Suruhanjaya (Cockfight)",
  comm_others: "Suruhanjaya (Lain-lain)",
  update_comm: "Kemas kini Komisen",
  update_carry_over: "Kemas Kini Dibawa",
  ewallet: "E-Dompet",
  withdrawal_list: "Senarai Pengeluaran",
  audit_withdrawal: "Pengeluaran Audit",
  daily_withdrawal: "Pengeluaran Harian",
  adjustment_log_affiliate: "Log Pelarasan",
  daily_statement_affiliate: "Kenyataan Harian (Afiliasi)",
  adjustment_list_affiliate: "Senarai Pelarasan (Afiliasi)",
  earning: "Pendapatan",
  earning_total: "Jumlah Pendapatan",
  cost_total: "Jumlah Kos",
  pnl: "P&L",
  deposit_bonus: "Bonus Deposit",
  wl_sports: "WinLose (Sukan)",
  wl_slots: "WinLose (Slot)",
  wl_livecasino: "WinLose (Livecasino)",
  to_cockfight: "Perolehan (Cockfight)",
  wl_others: "WinLose (Lain-lain)",
  pct_platform: "Peratusan (Platform)",
  pct_sports: "Peratusan (Sukan)",
  pct_slots: "Peratusan (Slot)",
  pct_livecasino: "Peratusan (Livecasino)",
  pct_cockfight: "Peratusan (Pertarungan Ayam)",
  pct_others: "Peratusan (Lain-lain)",
  earning_sports: "Pendapatan (Sukan)",
  earning_slots: "Pendapatan (Slot)",
  earning_livecasino: "Pembelajaran (Livecasino)",
  earning_cockfight: "Pendapatan (Cockfight)",
  earning_others: "Pendapatan (Lain-lain)",
  cost_deposit_bonus: "Bonus Deposit Kos",
  cost_sports: "Kos (Sukan)",
  cost_slots: "Kos (Slot)",
  cost_livecasino: "Kos (Livecasino)",
  cost_cockfight: "Kos (Cockfight)",
  cost_others: "Kos (Lain-lain)",
  review_affiliate_ticket: "Semak Tiket Gabungan",
  audit_affiliate_ticket: "Tiket Gabungan Audit",
  turnover_downline: "Perolehan (Turun)",
  valid_turnover_downline: "Perolehan Sah (Turun)",
  winlose_downline: "WinLose (Turun)",
  bet_count_downline: "Bet Count (Downline)",
  turnover_member: "Perolehan (Ahli)",
  valid_turnover_member: "Perolehan Sah (Ahli)",
  winlose_member: "WinLose (Ahli)",
  bet_count_member: "Bet Count (Ahli)",
  dashboard_affiliate: "Papan Pemuka (Afiliasi)",
  total_agent: "Jumlah Ejen",
  top_turnover: "Perolehan Teratas",
  daily_deposit: "Deposit Harian",
  bonus_count: "Bonus Count",
  deposit_amount_downline: "Jumlah Deposit (Turun)",
  deposit_count_downline: "Kiraan Deposit (Turun)",
  bonus_amount_downline: "Jumlah Bonus (Turun)",
  bonus_count_downline: "Bonus Count (Turun)",
  deposit_amount_member: "Jumlah Deposit (Ahli)",
  deposit_count_member: "Kiraan Deposit (Ahli)",
  bonus_amount_member: "Jumlah Bonus (Ahli)",
  bonus_count_member: "Bonus Count (Ahli)",
  verified: "Disahkan",
  round_id: "ID Bulat",
  unfinish_round: "Pusingan Belum Selesai",
  smartico_bonus_report: "Laporan Bonus Smarttico",
  unclaimed_amount: "Jumlah Tidak Dituntut",
  claimed_amount: "Jumlah Dituntut",
  unclaimed_count: "Kiraan Tidak Dituntut",
  claimed_count: "Kiraan Dituntut",
  submit_time: "Tarikh Dicipta",
  deposit_time: "Tarikh Diubah Suai",
  player_funds: "Tiket",
  funds_list: "Senarai Tiket",
  daifu_list_auto_withdrawal: "Senarai Tiket (Pengeluaran Auto)",
  btn_href: "Butang Href",
  btn_text: "Teks Butang",
  recent_inbox_claim: "Tuntutan Peti Masuk Terkini",
  raise_deposit_ticket_gateway: "Naikkan Tiket Deposit (Gateway)",
  gateway_acc: "Akaun Gerbang",
  provider_winlose_member: "Penyedia Winlose (Ahli)",
  review_by: "Semakan Oleh",
  daifu_list_auto_withdrawal_export: "Eksport Tiket (Pengeluaran Auto)",
  retention: "Retenton",
  current_month_active_user: "Pengguna Aktif Bulan Semasa",
  current_month_active: "Bulan Semasa Aktif",
  first_month: "Bulan Pertama",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "Jumlah FMDeposit",
  cohort: "Kohort",
  promotion_withdrawal_summary: "Ringkasan Pengeluaran Promosi",
  unique_player: "Pemain Unik",
  year: "Tahun | Tahun",
  audit_time_modified: "Tarikh Diubah Suai",
  audit_time_created: "Tarikh Dicipta",
  approve_time: "Tarikh Diubah Suai",
  unique_login_count: "Kiraan Log Masuk Unik",
  unique_withdrawal_count: "Kiraan Pengeluaran Unik",
  second_deposit_count: "Kiraan Deposit Kedua",
  unique_login: "Log Masuk Unik",
  unique_withdrawal: "Pengeluaran Unik",
  second_deposit: "Deposit Kedua",
  deposit_withdrawal_different: "Pengeluaran Deposit Berbeza",
  ngr: "NGR",
  audit_list: "Senarai Audit",
  rollback_count: "Rollback Count",
  rejected_ticket_id: "ID Tiket Ditolak",
  rollback: "Rollback",
  recipient_bank_acc_holder: "Pemegang Acc Bank Penerima",
  reject_date: "Tolak Tarikh",
  processing_date: "Tarikh Pemprosesan",
  manual_approve: "Luluskan (Manual)",
  pending_review_funds: "Tiket Belum Selesai & Semakan",
  table_id: "ID Jadual",
  member_label: "Label Ahli",
  label_name: "Nama Label",
  label: "Label",
  available_label: "Label Tersedia",
  bank_default_sender: "Pengirim Lalai Bank",
  amount_limit: "Had Amaun",
  bank_type: "Jenis Bank",
  bank_desc: "Bank Desc",
  iframe: "Iframe",
  iframe_url: "URL Iframe",
  exchange_rate: "Kadar Pertukaran",
  rate: "Kadar",
  rate_php: "Kadar PHP",
  ticket_withdrawal_rollback: "Pemulangan Pengeluaran Tiket",
  smartico_bonus_report_expired: "Laporan Bonus Smart (Tamat Tempoh)",
  reward_type: "Jenis Ganjaran",
  turnover_rebate: "Rebat Pusing Ganti",
  turnover_rebate_1: "Tier VIP",
  turnover_rebate_2: "Tier Pusing Ganti",
  vip_cycle_day: "Hari Kitaran VIP",
  vip_maintain_deposit: "VIP Kekalkan Deposit",
  vip_maintain_turnover: "VIP Mengekalkan Pengeluaran",
  is_addon: "Adakah Addon",
  no_reward: "Tiada ganjaran",
  cash: "Tunai",
  cs: "Perkhidmatan Pelanggan",
  social_platform: "Platform Sosial",
  edit_vip: "Edit VIP",
  edit_vip_provider: "Edit Pembekal VIP",
  turnover_tier: "Tier Pusing Ganti",
  rebate_rate: "Kadar Debat",
  edit_turnover_tier: "Edit Peringkat Perolehan",
  delete_turnover_tier: "Padam Peringkat Pusing Ganti",
  vip_log: "Log VIP",
  member_full_record: "Rekod Penuh Ahli",
  level: "tahap | lvl",
  before: "Sebelum ini",
  after: "Selepas",
  maintain: "Kekalkan",
  actual_rebate: "Rebat Sebenar",
  rounded_rebate: "Rebat Bulat",
  rebate_list: "Senarai Pulangan",
  rebate_mode: "Mod Bebat",
  inbox_id: "ID Peti Masuk",
  rebate_type: "Jenis Debat",
  rebate_list_member: "Senarai Debat (Ahli)",
  promotion_type: "Jenis Promosi",
  bonus_rate_1: "Kadar 1(%)",
  bonus_rate_2: "Kadar 2(%)",
  bonus_rate_3: "Kadar 3(%)",
  bonus_rate_4: "Kadar 4(%)",
  bonus_rate_5: "Kadar 5(%)",
  bonus_rate_6: "Kadar 6(%)",
  bonus_rate_7: "Kadar 7(%)",
  bonus_rate_8: "Kadar 8(%)",
  bonus_rate_9: "Kadar 9(%)",
  bonus_rate_10: "Kadar 10(%)",
  delete_all: "Padam Semua",
  rescue_fund: "Dana Penyelamat",
  up: "Naik",
  down: "Bawah",
  rate_percent: "Kadar %",
  rescue_fund_payout: "Pembayaran Dana Penyelamat",
  cycle: "Kitaran",
  actual_amount: "Jumlah Sebenar",
  rounded_amount: "Jumlah Bulat",
  payout_list: "Senarai Pembayaran",
  rescue_id: "ID Penyelamat",
  rescue_name: "Nama Penyelamat",
  min_lose: "Min Kalah",
  max_payout: "Pembayaran Maks",
  payout_method: "Kaedah Pembayaran",
  target_group: "Kumpulan Sasaran",
  member_vip_id: "ID VIP Ahli",
  member_vip_name: "Nama VIP Ahli",
  member_vip_level: "Peringkat VIP Ahli",
  rescue_vip_id: "ID VIP penyelamat",
  rescue_vip_name: "Selamatkan Nama VIP",
  rescue_vip_level: "Tahap VIP Penyelamat",
  daily: "Harian",
  weekly: "Mingguan",
  monthly: "Bulanan",
  edit_batch: "Edit Kelompok",
  current_level: "Tahap Semasa",
  next_level: "Peringkat Seterusnya",
  rescue: "Menyelamat",
  bet_value: "Nilai Pertaruhan",
  line_bet: "Pertaruhan Talian",
  total_round: "Jumlah Pusingan",
  audit_by: "Audit Oleh",
  possible_next_level: "Kemungkinan Tahap Seterusnya",
  maintain_deposit: "Kekalkan Deposit",
  maintain_turnover: "Kekalkan Perolehan",
  starting_deposit: "Deposit Permulaan",
  starting_turnover: "Mulakan Perolehan",
  cycle_deposit: "Deposit Kitaran",
  cycle_turnover: "Perolehan Kitaran",
  vip_list: "Senarai VIP",
  up_maintain: "Up Maintain",
  down_lowest: "Turun Terendah",
  manual: "Manual",
  daily_winlose_game: "Winlose Harian (Permainan)",
  action_affiliate: "Tindakan (Afiliasi)",
  actionaff: "Tindakan (Afiliasi)",
  onload: "muat",
  update_status: "Kemas kini Status",
  role_settings: "Tetapan Peranan",
  customer_services: "Perkhidmatan Pelanggan",
  marketing: "Pemasaran",
  finance: "Kewangan",
  payment: "Pembayaran",
  risk_management: "Pengurusan Risiko",
  winlose_turnover: "WL/TO",
  pt_percentage: "PT %",
  pt: "PT",
  wallet_history: "Sejarah Wallet",
  ticket_amount: "Jumlah Tiket",
  label_colour: "Warna label",
  ignore_risk: "Abaikan Risiko",
  permitted_amount: "Jumlah Dibenarkan",
  all_pending_ticket: "Semua Tiket Belum Selesai",
  rescue_fund_summary: "Ringkasan Dana Penyelamat",
  rescue_fund_summary_daily: "Ringkasan Dana Penyelamat Setiap Hari",
  rescue_fund_member: "Ahli Tabung Penyelamat",
  master: "Tuan",
  account_type: "Jenis Akaun",
  freeze: "Bekukan",
  domain_member_setup: "Persediaan Domain tapak ahli",
  domain: "Domain",
  domain_list: "Senarai Domain",
  domain_application: "Aplikasi Domain",
  domain_status: "Status Domain",
  domain_group: "Kumpulan Domain",
  operator_id: "ID Operator",
  domain_type: "Jenis Domain",
  taken_on: "Diambil",
  module: "Modul",
  template: "Templat",
  custom: "Tersuai",
  default: "Lalai",
  payment_provider: "Penyedia Pembayaran",
  payment: "Pembayaran",
  deactivate: "Tidak aktif",
  buy_on_behalf: "Beli Bagi Pihak",
  name_server: "Pelayan Nama",
  server_account: "Akaun Pelayan",
  service_provider: "Penyedia Perkhidmatan",
  process: "Proses",
  provider_operator: "Operator Pembekal",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  bet_limit_provider: "@:ui.bet_limit (@:ui.provider)",
  global: "Tetapan Global",
  second_id: "ID Kedua",
  unverified: "Tidak disahkan",
  operator_list: "Senarai Pengendali",
  available_operator_list: "Senarai Operator Tersedia",
  CN: "CN",
  pt_cockfight: "PT sabung ayam (%)",
  pt_livecasino: "Livecasino PT (%)",
  pt_others: "PT lain (%)",
  pt_slots: "Slot PT (%)",
  pt_sports: "Buku Sukan PT (%)",
  pt_gateway: "Payment Gateway PT (%)",
  pt_affiliate: "Caj Platform Gabungan (%)",
  recipient_bank: "Bank Penerima",
  payment_channel: "Saluran Pembayaran",
  deposit_type: "Jenis Deposit",
  security_fund: "Dana Keselamatan",
  topup_security_fund: "Top Up Security Fund",
  adjust_balance_op: "Laraskan Dompet Operator",
  adjust_security_deposit_op: "Laraskan Dana Keselamatan Operator",
  marquee: "Marquee",
  marquee_content: "Kandungan marquee",
  edit_marquee: "Edit Marquee",
  domain_available: "Domain Tersedia",
  payment_provider_co: "@:ui.payment_provider (@:ui.company)",
  payment_provider_gb: "@:ui.payment_provider (@:ui.global)",
  payment_option_co: "@:ui.payment_option (@:ui.company)",
  payment_option_gb: "@:ui.payment_option (@:ui.global)",
  bank_company: "@:ui.bank @:ui.company",


  daily_withdrawal_frequency: "Kekerapan Pengeluaran Harian",
  domain_price: "Harga Domain",
  maintenance: "Penyelenggaraan",
  max_withdrawal: "Pengeluaran Maks",
  min_balance: "Baki Minimum",
  platform_fee: "Yuran Platform",
  affiliate_report: "Laporan Gabungan",
  winlose_withdrawal_chart: "Kalah / Carta Pengeluaran",
  deposit_turnover_chart: "Deposit / Carta Pusing Ganti Sah",
  cost: "Kos",
  cash_balance: "Baki Tunai",
  security_deposit: "Dana Keselamatan",
  copy_success: "Salin berjaya!",
  copy_failed: "Salin gagal!",
  your_website: "Laman Web Anda",
  correction_promo: "Pembetulan(Promosi)",
  others: "Lain-lain",
  total_earning: "Jumlah Pendapatan",
  total_cost: "Jumlah Kos",
  cost_breakdown: "Pecahan Kos",
  is_proccesed: "Diproses",
  audit_log: "Log Audit",
  view: "Lihat",
  email_otp: "E-mel OTP",
  request_otp: "Permintaan OTP",
  price: "Harga",
  package_level: "Tahap Pakej",
  bo_right: "BO Betul",
  english: "Bahasa Inggeris",
  simplified_chinese: "Cina (CN)",
  traditional_chinese: "Cina (TW)",
  philippine: "Filipina",
  thai: "Thai",
  vietnamese: "Vietnam",
  indonesian: "Indonesia",
  myanmar: "Myanmar",
  japanese: "Bahasa Jepun",
  korean: "Korea",
  package_type: "Jenis Pakej",
  full_back_office_access_right: "Akses Pejabat Belakang Penuh Betul",
  read_only_back_office: "Baca Sahaja Belakang Pejabat",
  language: "Bahasa",
  lang_code: "Kod Bahasa",
  description: "Penerangan",
  provider_type: "Jenis Pembekal",
  logo: "Logo",
  provider_game: "Permainan Penyedia",
  payment_code: "Kod Gerbang Pembayaran",
  payment_name: "Nama Gerbang Pembayaran",
  recommended: "Disyorkan",
  theme_provider: "Penyedia Tema",
  theme_content: "Kandungan Tema",
  content_id: "ID Kandungan",
  content_desc: "Kandungan Desc",
  theme_content_position: "Kedudukan Kandungan Tema",
  theme: "Tema",
  theme_code: "Kod Tema",
  theme_name: "Nama Tema",
  color: "Warna",
  position: "Kedudukan",
  user_id: "ID pengguna",
  site_name: "Nama Tapak",
  step: "Langkah",
  theme_color: "Warna Tema",
  pending_payment: "Bayaran Belum Selesai",
  timeout: "Tamat masa",
  purchased: "Dibeli",
  pending_setup: "Persediaan Menunggu",
  completed: "Selesai",
  verified_on: "Disahkan Pada",
  email_verified_on: "E-mel Disahkan Pada",
  profile: "Profil",
  not_verified: "Tidak Disahkan",
  attempt_block: "Sekat Percubaan",
  company_block: "Blok Syarikat",
  phone_tac: "OTP telefon",
  email_tac: "E-mel OTP",
  tac: "OTP",
  tac_expiry: "OTP Tamat Tempoh",
  theme_purchased: "Tema Dibeli",
  total_purchased: "Jumlah Dibeli",
  purchased_date: "Tarikh Dibeli",
  purchase: "Beli",
  top_purchase: "Pembelian Teratas (Kereta)",
  user_count: "Kiraan Pengguna",
  purchase_count: "Kiraan Belian",
  active_site: "Tapak Aktif",
  total_site: "Jumlah Tapak",
  content_setup: "Persediaan Kandungan",
  site_list: "Senarai Tapak",
  site_id: "ID tapak",
  draft_version: "Versi Draf",
  prod_version: "Prod. Versi",
  production_version: "Versi Pengeluaran",
  info: "Maklumat",
  setting: "Tetapan",
  domain: "Domain",
  site_info: "Maklumat Tapak",
  site: "Laman",
  menu: "Menu",
  game_menu: "Menu Permainan",
  special_menu: "Menu Istimewa",
  setting_menu: "Menu Tetapan",
  error: "Ralat",
  sync_all: "Segerakkan Semua",
  site_details: "Butiran Tapak",
  old_value: "Nilai Lama",
  new_value: "Nilai Baru",
  theme_content_group: "Kumpulan Kandungan Tema",
  content_group: "Kumpulan Kandungan",
  content_group_desc: "Kumpulan Kandungan Desc",
  parent_content_id: "ID Kandungan Ibu Bapa",
  bo_default_domain: "Domain Lalai BO",
  domain_id: "ID Domain",
  deactive: "Tidak aktif",
  site_sync: "Penyegerakan Tapak",
  upload: "Muat naik",
  comingSoon: "Akan Datang",
  site_edit: "Sunting Tapak",
  profile_setting: "Tetapan Profil",
  bank: "Bank",
  company: "Syarikat",
  own: "SENDIRI",
  operator_setting: "Tetapan Operator",
  external_id: "ID Luaran",
  ticket: "Tiket",
  bank_owner: "Pemilik Bank",
  exchanged_currency: "Mata Wang Bertukar",
  company_bank_owner: "Pemilik Bank Syarikat",
  ticketoperator: "Tiket (Operator)",
  ticket_list_member: "Senarai Tiket (Ahli)",
  ticket_list_operator: "Senarai Tiket (Operator)",
  pending_ticket_list_operator: "Senarai Tiket Belum Selesai (Operator)",
  site_recreate: "Buat Semula Tapak",
  game_name_exclude: "Nama Permainan Kecualikan",
  tab: "Tab",
  about_us: "Tentang Kami",
  privacy_policy: "Dasar Privasi",
  responsible_gaming: "Perjudian Bertanggungjawab",
  banking: "Perbankan",
  faqs: "SOALAN LAZIM",
  advertisement: "Iklan",
  domain_op: "Domain (Operator)",
  px_pixel_id: "ID PX Pixel",
  px_token: "Token PX",
  af_dev_key: "Kunci Af Dev",
  af_apps_id: "ID Apl AF",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "BANTUAN PP",
  gtm_id: "ID GTM",
  service_provider_url: "URL Pembekal Perkhidmatan",
  script_inject: "Suntik Skrip",
  head_script: "Skrip Ketua",
  body_script: "Skrip Badan",
  ads_id: "ID Ads",
  min_deposit_operator: "Operator Deposit Min",
  member_detail: "Perincian Ahli",
  memberreport: "Laporan Ahli",
  member_log: "Log Ahli",
  dashboard_admin: "Papan Pemuka (Pentadbir)",
  general: "Umum",
  top_theme: "Tema Teratas",
  hot_game: "Permainan Panas",
  hot_list: "Senarai Panas",
  total_winlose_by_category: "Jumlah Winlose Mengikut Kategori",
  new_game: "Permainan Baru",
  popular_game: "Permainan Popular",
  featured_game: "Permainan Pilihan",
  new_list: "Senarai Baharu",
  popular_list: "Senarai Popular",
  featured_list: "Senarai Pilihan",
  provider_new_game: "Permainan Baharu Penyedia",
  provider_popular_game: "Permainan Popular Penyedia",
  provider_featured_game: "Permainan Pilihan Penyedia",
  pending_master_list: "Senarai Induk Belum Selesai",
  website: "Laman web",
  site_customization: "Penyesuaian Tapak",
  export_all: "Eksport semua",
  export_one: "Eksport (Halaman Semasa)",
  daily_ledger: "Lejar Harian",
  daily_ledger_member: "Lejar Harian (Ahli)",
  promotion_signup_unused: "Promosi Pendaftaran Tidak Digunakan",
  promotion_signup_ongoing: "Menyertai Promosi Pendaftaran",
  promotion_signup_winlose: "Tandatangan Promosi Winlose",
  promotion_signup_winlose_operator: "Tandatangan Promosi Winlose (Operator)",
  promotion_signup_winlose_member: "Tandatangan Promosi Winlose (Ahli)",
  total_player_balance: "Jumlah Baki Pemain",
  search_all: "Cari Semua",
  gateway_name: "Nama Gerbang",
  mbsetting: "Tetapan",
  todays_highlights: "Sorotan Hari Ini",
  deposit_player: "Pemain Deposit",
  withdrawal_player: "Pemain Pengeluaran",
  kill_rate: "Kadar Bunuh",
  login_player: "Pemain Log Masuk",
  operation_management: "Operasi",
  game_management: "Permainan",
  member_management: "Ahli",
  affiliate_management: "Afiliasi",
  promotion_management: "Promosi",
  risk_management: "Pengurusan Risiko",
  system_settings: "Tetapan Sistem",
  mbcampaign: "Kempen",
  promo_allday: "Sepanjang Hari",
  promo_daily: "Harian",
  promo_daily_first_deposit: "Deposit Pertama Harian",
  promo_deposit_monthly: "Kiraan Deposit Bulanan",
  promo_deposit_signup: "Deposit Count Signup",
  promo_deposit_weekly: "Deposit Kiraan Mingguan",
  promo_newbie: "Baharu",
  promo_once: "Sekali",
  dd_review: "Semakan",
  game_provider_management: "Penyedia",
  exchanged_amount: "Jumlah Bertukar",
  operator_summary: "Ringkasan Pengendali",
  business_id: "ID perniagaan",
  game_name_exclude_log: "Nama Permainan Kecualikan Log",
  cn: "CN",
  local: "TEMPATAN",
  taken: "Diambil",
  receiver_bank: "Bank Penerima",
  receiver_bank_acc_no: "No. Acc Bank Penerima",
  receiver_bank_acc_holder: "Pemegang Acc Bank Penerima",
  add_balance: "Tambah Baki",
  deduct_balance: "Imbangan Saluran",
  sync_site_content: "Segerakkan Kandungan Tapak",
  payment_setting: "Tetapan Pembayaran",
  payment_own: "SENDIRI",
  payment_global: "GLOBAL",
  livechat: "LiveChat",
  chat_id: "Kunci Lesen LiveChat",
  chat_provider: "Penyedia LiveChat",
  account_list: "Senarai Akaun",
  copy_list: "Senarai Salinan",
  access_auto_list: "Senarai Pelantikan Automatik",

  create: "Cipta",
  hint: "Petunjuk",
  quickSetup: "Persediaan Pantas",
  next: "Seterusnya",
  setUpTheme: "Tetapkan Tema",
  checkOut: "Semak Keluar",
  standardPackage: "Pakej Standard",
  siteName: "Nama Laman",
  information: "Maklumat",
  useThisTemplate: "Gunakan Templat Ini",
  orderTimeAndDate: "Masa & Tarikh Pesanan",
  packageLimit: "Had Pakej",
  summary: "Ringkasan",
  createOperatorAccount: "Cipta Akaun Operator",
  operatorId: "ID Operator",
  operatorPwd: "Kata Laluan Operator",
  click: "Klik",
  toLogin: "untuk Log Masuk",
  new_website: "Laman Web Baharu",
  new_website_list: "Senarai Laman Web Baharu",
  website_id: "ID Laman Web",
  cart_list: "Senarai Kereta",
  cart: "Kereta",
  cart_id: "ID troli",
  operator_information: "Maklumat Operator",
  bo_link: "Pautan Backend",

  daily_summary_sms: "Ringkasan SMS Harian",
  daily_summary_sms_operator: "Ringkasan SMS Harian Operator",
  daily_summary_sms_operator_detail: "Butiran Ringkasan SMS Harian Operator",
  sms_count: "Kiraan SMS",

  provider_winlose_operator_pt: "Provider Winlose (Operator PT)",
  pt_on: "PT On",
  share_operator: "Operator Berkongsi",
  share_company: "Syarikat Berkongsi",

  token_log: "Log Token",
  action_type: "Jenis Tindakan",
  
  template_code: "Kod Templat",
  template_name: "Nama Templat",
  mini_game: "Permainan Mini",
  max_game_reward: "Ganjaran Maksimum Permainan",
  max_chance_per_day: "Peluang Maksimum setiap Hari",
  is_recurring_chance: "Berulang",
  token_request: "Token",
  enabled: "Diaktifkan",
  disabled: "Dinonaktifkan",
  unlimited: "Tanpa Had",
  max_chance_unlimited: "Peluang Maksimum setiap Hari Tanpa Had",
  mini_game_template: "Templat Permainan Mini",
  reward_code: "Kod Ganjaran",
  reward_name: "Nama Ganjaran",
  reward_description: "Huraian Ganjaran",
  reward_probability: "Kebarangkalian Ganjaran",
  total_game: "Jumlah Permainan",
  total_played_mini_game: "Jumlah Permainan Mini yang Dimainkan",
  total_played_mini_game_detail: "Butiran Jumlah Permainan Mini yang Dimainkan",
  total_played_mini_game_detail_operator: "Butiran Jumlah Permainan Mini yang Dimainkan (Operator)",
  daily_pnl_operator: "P&L Harian (Operator)",
  token: "Token",
  gamify: "Gamifikasi",
  token_1: "Token 1",
  token_2: "Token 2",
  token_3: "Token 3",
  token_4: "Token 4",
  token_5: "Token 5",
  token_6: "Token 6",
  token_7: "Token 7",
  cash_1: "Tunai 1",
  cash_2: "Tunai 2",
  cash_3: "Tunai 3",
  cash_4: "Tunai 4",
  cash_5: "Tunai 5",
  cash_6: "Tunai 6",
  cash_7: "Tunai 7",
  daily_login: "Daftar Masuk Harian (Check-in Harian)",
  daily_login_update: "Kemas Kini Daftar Masuk Harian (Check-in Harian)",
  game_result_reward: "Ganjaran Keputusan Permainan",
  current_streak: "Rentetan Semasa",
  login_streak: "Rentetan Log Masuk",
  total_token: "Jumlah Token",
  total_mini_game_token_used: "Jumlah Token Mini Game Digunakan",
  total_mini_game_token_used_detail: "Perincian Jumlah Token Mini Game Digunakan",
  total_mini_game_token_used_detail_operator: "Perincian Jumlah Token Mini Game Digunakan (Operator)",
  total_reward: "Jumlah Ganjaran",
  total_mini_game_reward: "Jumlah Ganjaran Mini Game",
  total_mini_game_reward_detail: "Perincian Jumlah Ganjaran Mini Game",
  total_mini_game_reward_detail_operator: "Perincian Jumlah Ganjaran Mini Game (Operator)",
  token_balance: "Baki Token",
  free_game_token: "Token Permainan Percuma",
  bo_url: "URL Pejabat Belakang",
  copied: "Disalin",

  callback: "Callback",
  api: "API",
  prefix: "Awalan",
  delimiter: "Pemisah",

  url_callback_deposit: "URL Callback Deposit",
  url_callback_withdrawal: "URL Callback Pengeluaran",
  url_callback_affiliate: "URL Callback Afiliasi",
  url_api_deposit: "URL Callback Deposit (API)",
  url_api_withdrawal: "URL Callback Pengeluaran (API)",
  url_api_balance: "URL Callback Baki (API)",
  prefix_deposit: "Awalan Deposit",
  prefix_withdrawal: "Awalan Pengeluaran",
  prefix_affiliate: "Awalan Afiliasi",
  prefix_delimiter: "Pemisah Awalan",

  merchant: "Peniaga",
  app_id: "ID Apl",
  secret_key: "Kunci Rahsia",
  deposit_secret_key: "Kunci Rahsia Deposit",
  withdrawal_secret_key: "Kunci Rahsia Pengeluaran",
  partners: "Rakan Kongsi",
  partner_name: "Nama Rakan Kongsi",
  win: "Menang"

}